/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../../constants';
const elementName = `${COMPONENT_NAME_PREFIX}view`;
export const VIEW_CONSTANTS = {
    elementName
};
